module.exports = __webpack_public_path__ + "img/banner_b.43e9e5b0.jpg";